import { render, staticRenderFns } from "./AssetDropZone.vue?vue&type=template&id=dd58444a&"
import script from "./AssetDropZone.vue?vue&type=script&lang=js&"
export * from "./AssetDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports